import { render, staticRenderFns } from "./service-order-card.vue?vue&type=template&id=f25d26c2"
import script from "./service-order-card.vue?vue&type=script&lang=js"
export * from "./service-order-card.vue?vue&type=script&lang=js"
import style0 from "./service-order-card.vue?vue&type=style&index=0&id=f25d26c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports